import { LazyLoad } from 'app/utils';

export const BannerListPage = LazyLoad(
  () => import('./index'),
  (module) => module.BannerListPage,
);
